import React, { useState } from "react";
import { Modal } from "antd";
import { ArchiveBoxIcon } from "../../assets/icons/ArchiveBoxIcon";

// The delete confirmation's look (DeleteComponent), for archiving.
import "../../pages/workspace/style.scss";

/**
 * Asks before a workspace or a project is archived. `label` is "workspace" or
 * "project"; `onConfirm` archives it, and the dialog stays until it is done.
 */
function ArchiveConfirmModal({ open, label, onCancel, onConfirm }) {
   const [isArchiving, setIsArchiving] = useState(false);

   const confirm = async () => {
      setIsArchiving(true);
      try {
         await onConfirm();
      } finally {
         setIsArchiving(false);
      }
   };

   return (
      <Modal
         open={open}
         onCancel={onCancel}
         footer={null}
         className="workspace-modal"
         closable={false}
         width={600}
      >
         <div className="remove-modal d-flex flex-column align-content-center text-center">
            <p>
               <span>
                  <ArchiveBoxIcon />
               </span>
            </p>
            <h3 className="deleteHeading">Archive {label}</h3>
            <p className="paragraphTextItem">Are you sure you want to archive this {label}?</p>
            <p className="paragraphText">
               It is hidden from everyone and doesn't count toward your plan, and its surveys stop
               collecting answers. Nothing in it is deleted: you can restore it from the archived{" "}
               {label}s whenever your plan has room for it.
            </p>
         </div>
         <div className="delete-modal-button-group">
            <button onClick={onCancel} className="delete-modal-cancel" disabled={isArchiving}>
               No, keep it
            </button>
            <button onClick={confirm} className="yes-i-want-this" disabled={isArchiving}>
               Yes, archive it
            </button>
         </div>
      </Modal>
   );
}

export default ArchiveConfirmModal;
